module.exports = __webpack_public_path__ + "static/media/Thomas Pinckney - 1796.5a1bac9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Thomas Pinckney - 1796.jpg
// module id = 557
// module chunks = 0